var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
import { Apphandler } from "@/ipc/MainAppHandler";
import { BaseDialogState } from "@/app/UIComponents/BaseDialog";
import { APPEvent } from "@/events/AppEvents";
export class PoliciesStore {
    constructor() {
        this.loading = false;
        this.accepting = false;
        this.policies = [];
        this.basedialogState = new BaseDialogState();
        makeObservable(this);
        APPEvent.addSubscriberForPoliciesAccepted((acc) => {
            if (!acc) {
                this.getPolicies();
                this.setOpen(true);
            }
            else {
                this.setOpen(false);
            }
        });
        this.basedialogState.setOkLabel("Accept");
        this.basedialogState.setHeaderLabel("Policies");
        this.basedialogState.setHideCancelButton(true);
        this.basedialogState.setHideCloseButton(true);
        this.basedialogState.setModalSize("6xl");
        this.basedialogState.onOk = () => {
            this.accept();
        };
        APPEvent.addSubscriberForPolicies((policies) => {
            this.setLoading(false);
            policies.map((p) => {
                this.addPolicy(p);
            });
        });
    }
    addPolicy(p) {
        this.policies.push(p);
    }
    clearPolicies() {
        this.policies = [];
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setAcepting(accepting) {
        this.accepting = accepting;
    }
    async accept() {
        this.setAcepting(true);
        Apphandler.sendMessage("acceptpolicies", "");
    }
    async getPolicies() {
        this.setLoading(true);
        Apphandler.sendMessage("policies", "");
    }
    reset() {
        this.policies = [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PoliciesStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PoliciesStore.prototype, "accepting", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], PoliciesStore.prototype, "policies", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PoliciesStore.prototype, "addPolicy", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PoliciesStore.prototype, "clearPolicies", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], PoliciesStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], PoliciesStore.prototype, "setAcepting", null);
